import { IIconProps } from "../types"

export default function IconUL7(props: IIconProps) {
  const width = props.size || props.width || 95
  const height = props.size || props.height || 74
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 95 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.6896 1.06265C54.5496 0.702651 48.3596 0.632651 42.3396 0.962651C36.3196 1.28265 30.4596 2.00265 26.2596 2.95265C22.0596 3.89265 19.5196 5.06265 17.1096 7.18265C14.7096 9.29265 12.4296 12.3527 9.94963 16.8127C7.47963 21.2727 4.80963 27.1327 3.20963 31.2027C1.61963 35.2727 1.09963 37.5527 0.869632 40.9726C0.639632 44.3827 0.709632 48.9426 1.35963 52.6227C2.00963 56.3027 3.24963 59.1026 4.64963 61.8027C6.04963 64.5027 7.60963 67.1126 9.42963 68.9326C11.2596 70.7526 13.3396 71.7926 15.6496 72.2826C17.9596 72.7727 20.4996 72.7126 23.6896 72.2826C26.8796 71.8626 30.7196 71.0826 35.7696 70.2626C40.8096 69.4527 47.0596 68.6027 51.6796 68.6426C56.3096 68.6727 59.2996 69.5826 61.8096 70.3626C64.3196 71.1426 66.3296 71.7926 68.8096 71.7327C71.2796 71.6627 74.2096 70.8827 77.0696 69.5126C79.9396 68.1526 82.7396 66.1926 85.4096 63.0727C88.0796 59.9426 90.6196 55.6526 92.1796 51.4827C93.7396 47.3126 94.3296 43.2826 93.5496 38.5927C92.7696 33.9026 90.6196 28.5627 88.2696 23.3927C85.9296 18.2127 83.3896 13.2027 80.8196 9.78265C78.2496 6.36265 75.6396 4.54265 72.2896 3.30265C68.9396 2.07265 64.8396 1.42265 59.6896 1.06265Z"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 2.7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.6307 27.1328C52.6607 30.6528 48.6907 34.1628 47.2907 41.1028C45.8807 48.0428 47.0507 58.3928 48.2107 68.7528"
        fill="white"
      />
      <path
        d="M56.6307 27.1328C52.6607 30.6528 48.6907 34.1628 47.2907 41.1028C45.8807 48.0428 47.0507 58.3928 48.2107 68.7528"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 2.7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1406 27.5234C30.5906 29.4134 34.0406 31.3034 37.4006 32.8334C40.7706 34.3534 44.0506 35.5234 45.6806 36.8434C47.3106 38.1634 47.3006 39.6334 47.2906 41.1034"
        fill="white"
      />
      <path
        d="M27.1406 27.5234C30.5906 29.4134 34.0406 31.3034 37.4006 32.8334C40.7706 34.3534 44.0506 35.5234 45.6806 36.8434C47.3106 38.1634 47.3006 39.6334 47.2906 41.1034"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 2.7"
      />
    </svg>
  )
}
